/* unplugin-vue-components disabled */import script from "./meeting-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./meeting-modal.vue?vue&type=script&setup=true&lang=js"

import "./meeting-modal.vue?vue&type=style&index=0&id=5a8d50a5&lang=scss"

const __exports__ = script;

export default __exports__